<template>
  <Layout>
    <PageHeaderV2 :title="$t('videoHistory.pageTitle')" :subTitle="$t('videoHistory.pageDesc')">
      <template #afterTitle>
        <div class="d-flex gap-2">
          <McButtonBack :href="`/live-streaming`" />
          <McButton
            variant="outline-primary"
            :text="$t('trackVideo.historyVideoDownload')"
            icon="icon-outline_file-text"
            @click="goToVideoHistory"
          />
        </div>
      </template>
    </PageHeaderV2>
    <MainContent />
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeaderV2 from '@/components/page-header-v2.vue'
import McButtonBack from '@/components/McButtonBack'
import McButton from '@/components/McButton'
import MainContent from './components/MainContent'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  name: 'VideoHistoryNew',
  page: {
    title: 'Riwayat Video New',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeaderV2,
    McButtonBack,
    McButton,
    MainContent,
  },
  mixins: [Helper, MixPanel],
  methods: {
    goToVideoHistory() {
      this.track('Open Video Download History')
      this.$router.push({
        name: 'Video History Trackvision Download',
        query: {
          prevPage: 'video-history',
          videoHistoryVehicleId: this.$route.query.vehicleId,
          // ...(this.isVideoDemo ? { isDemo: true } : {}),
        },
      })
    },
  },
}
</script>

<style lang="scss">
@import './style.scss';
</style>
